import { SearchParams } from '@synergy/models';
import { connect } from 'react-redux';
import { padZeroLeft } from '@synergy/utils';

import { AppState } from '../../../../store/models/app-state';
import { BaseAutocompleteSuggestionType } from '../../autocomplete-list/pool-autocomplete-list';
import { PoolFormAutocompleteList } from '../../abstract/form-autocomplete-list';
import { Supplier } from '../../../models/supplier';
import { fetchRelatedSuppliers, resetSuppliersSearchParams } from '../../../actions/supplier-actions';

export interface PartialSupplier extends BaseAutocompleteSuggestionType {
    name: string;
}

interface PoolSupplierAutocompleteListProps {
    items: Supplier[];
    inProgress: boolean;
    fetchSuppliers: (searchParams: SearchParams) => void;
    resetSuppliersSearchParams: () => void;
}

class PoolSupplierAutocompleteListBase extends PoolFormAutocompleteList<
    Supplier,
    PartialSupplier,
    PoolSupplierAutocompleteListProps
> {
    public override componentDidMount() {
        this.props.resetSuppliersSearchParams();
        super.componentDidMount();
    }

    public getSuggestionValue = (suggestion: PartialSupplier) => suggestion && suggestion.name;

    public override handleValueChanged(search: string) {
        this.props.fetchSuppliers({ search });
    }

    public getPartial = (items: Supplier[]): PartialSupplier[] => {
        return items.map(supplier => {
            return {
                id: padZeroLeft(supplier.id, 5),
                name: supplier.name,
            };
        });
    };
}

const mapStateToProps = (state: AppState) => ({
    items: state.suppliers.flat.items,
    inProgress: state.suppliers.requesting,
});

export const PoolSupplierAutocompleteList = connect(mapStateToProps, {
    fetchSuppliers: fetchRelatedSuppliers,
    resetSuppliersSearchParams,
})(PoolSupplierAutocompleteListBase);
